module.exports = __webpack_public_path__ + "img/banner-image-md.9530c39a.png";